'use client'

import { useMemo } from 'react'
import { useParams } from 'next/navigation'

import { findNavItem, usePathname } from '@/navigation'
import type { NavItem } from '@/navigation'

export function useCurrentNavItem(): { currentNavItem?: NavItem; id?: string } {
  const pathname = usePathname()
  const params = useParams() as Record<string, string | string[] | undefined>

  const rawId =
    params?.id || params?.property || params?.orderID || params?.fieldId
  const id = typeof rawId === 'string' ? rawId : rawId?.[0]

  const currentNavItem = useMemo(
    () => findNavItem(pathname, id),
    [pathname, id],
  )

  return { currentNavItem, id }
}
